import { DesktopMainFrame } from "@/desktop/components/DesktopMainFrame";
import { Typography } from "@mui/material";

export function DesktopTimeBookingPage() {
    return <DesktopMainFrame>
        <Typography>DesktopTimeBookingPage</Typography>
    </DesktopMainFrame>;
}